import { learnerPaths } from '@app/routes/route-paths'
import type { LearnerRouteDefinition } from '@app/routes/learner-route-types'

export const profileRouteDefinitions = [
  {
    id: 'profile',
    legacyScreen: 1,
    navLabel: 'Profile',
    path: learnerPaths.profile,
    showInMainMenu: true,
    title: 'Profile',
  },
  {
    id: 'settings',
    legacyScreen: 2,
    navLabel: 'Settings',
    path: learnerPaths.settings,
    showInMainMenu: true,
    title: 'Settings',
  },
] satisfies readonly LearnerRouteDefinition[]
